(() => {
  if (window.__babaluReturnNavigationV9) return;
  window.__babaluReturnNavigationV9 = true;

  const storageKey = 'babalu:return-navigation:v9';
  const stateKey = 'babaluCollectionReturn';
  const nativeBackKey = 'babaluNativeBackArmed';
  const nativeReturnParam = 'brp';
  const maxAge = 30 * 60 * 1000;
  const productSelector = 'hdt-card-product[data-product-id]';
  const collectionSelector = 'hdt-reval-items[id^="products-"]';
  let restoringCollectionPoint = false;

  const pageFromUrl = () => {
    const page = Number.parseInt(new URL(window.location.href).searchParams.get('page'), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  };

  const safeRead = () => {
    for (const storage of [window.sessionStorage, window.localStorage]) {
      try {
        const point = JSON.parse(storage.getItem(storageKey));
        if (point && Date.now() - point.createdAt < maxAge) return point;
      } catch (_) {
        // Safari private browsing can deny a storage area; try the next one.
      }
    }
    return null;
  };

  const safeWrite = (point) => {
    // sessionStorage is the primary store: the return belongs to this tab.
    // localStorage is used only when Safari denies sessionStorage entirely.
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(point));
      return;
    } catch (_) {
      // Continue with the constrained fallback below.
    }
    try { window.localStorage.setItem(storageKey, JSON.stringify(point)); } catch (_) { /* unavailable */ }
  };

  const safeRemove = () => {
    for (const storage of [window.sessionStorage, window.localStorage]) {
      try { storage.removeItem(storageKey); } catch (_) { /* continue */ }
    }
  };

  const pointFromState = () => {
    const point = window.history.state?.[stateKey];
    return point && Date.now() - point.createdAt < maxAge ? point : null;
  };

  const pointFromNativeUrl = () => {
    const url = new URL(window.location.href);
    const parts = url.searchParams.get(nativeReturnParam)?.split('~');
    const [productId, offset] = parts || [];
    const numericOffset = Number.parseInt(offset, 10);
    if (!/^\d+$/.test(productId || '') || !Number.isFinite(numericOffset)) return null;
    url.searchParams.delete(nativeReturnParam);
    return {
      productId,
      returnUrl: `${url.pathname}${url.search}`,
      page: pageFromUrl(),
      offset: numericOffset,
      createdAt: Date.now(),
    };
  };

  const currentPoint = () => pointFromNativeUrl() || pointFromState() || safeRead();
  const collectionProducts = () => Array.from(document.querySelectorAll(`${collectionSelector} > ${productSelector}`));

  const disableInstantProductLinks = (source = document) => {
    source.querySelectorAll(`${collectionSelector} ${productSelector} a[data-pr-url][data-instant]`).forEach((link) => {
      link.removeAttribute('data-instant');
      link.setAttribute('data-no-instant', '');
    });
  };

  const pageFromMarker = (product) => {
    const marker = Array.from(product.classList).find((className) => /^point-effect-\d+$/.test(className));
    return marker ? Number.parseInt(marker.replace('point-effect-', ''), 10) : null;
  };

  const markProducts = (page, onlyUnmarked = true) => {
    collectionProducts().forEach((product) => {
      if (!onlyUnmarked || !product.dataset.infinitePage) product.dataset.infinitePage = String(page);
    });
  };

  const pageForProduct = (product) => {
    const assigned = Number.parseInt(product.dataset.infinitePage, 10);
    return Number.isFinite(assigned) && assigned > 0 ? assigned : (pageFromMarker(product) || pageFromUrl());
  };

  let scrollFrame;
  const syncVisiblePage = () => {
    const target = window.innerHeight * 0.45;
    let closest;
    collectionProducts().forEach((product) => {
      const rect = product.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const distance = Math.abs(rect.top + rect.height / 2 - target);
      if (!closest || distance < closest.distance) closest = { distance, page: pageForProduct(product) };
    });
    if (!closest) return;
    const url = new URL(window.location.href);
    if (closest.page > 1) url.searchParams.set('page', String(closest.page));
    else url.searchParams.delete('page');
    window.history.replaceState({ ...(window.history.state || {}), collectionReturnPage: closest.page }, '', url);
  };

  const scheduleVisiblePageSync = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = undefined;
      syncVisiblePage();
    });
  };

  const isPrimaryActivation = (event) => !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
    && (event.type !== 'click' || event.button === 0);

  const prepareProductNavigation = (event) => {
    if (!(event.target instanceof Element) || !isPrimaryActivation(event)) return null;
    const link = event.target.closest(`${productSelector} a[data-pr-url]`);
    const product = link?.closest(productSelector);
    const productId = product?.dataset.productId;
    if (!link || !product || !/^\d+$/.test(productId || '')) return null;

    const page = pageForProduct(product);
    const returnUrl = new URL(window.location.href);
    ['return_collection', 'return_page', 'return_product_id', 'return_offset'].forEach((name) => returnUrl.searchParams.delete(name));
    if (page > 1) returnUrl.searchParams.set('page', String(page));
    else returnUrl.searchParams.delete('page');
    returnUrl.hash = '';

    const point = {
      productId: String(productId),
      productPath: new URL(link.href, window.location.origin).pathname,
      returnUrl: `${returnUrl.pathname}${returnUrl.search}`,
      page,
      offset: Math.round(product.getBoundingClientRect().top),
      createdAt: Date.now(),
    };
    safeWrite(point);
    window.history.replaceState({ ...(window.history.state || {}), [stateKey]: point }, '', returnUrl);

    const productUrl = new URL(link.href, window.location.origin);
    ['return_collection', 'return_page', 'return_product_id', 'return_offset'].forEach((name) => productUrl.searchParams.delete(name));
    link.href = productUrl.toString();
    return productUrl.toString();
  };

  const prepareWithoutNavigation = (event) => {
    if (!prepareProductNavigation(event)) return;
    event.stopImmediatePropagation();
  };

  const openPreparedProduct = (event) => {
    const productUrl = prepareProductNavigation(event);
    if (!productUrl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(productUrl);
  };

  const pointMatchesCurrentProduct = (point) => point
    && window.location.pathname === point.productPath;

  const returnToCollection = (point) => {
    if (!point?.returnUrl) return false;
    window.location.assign(point.returnUrl);
    return true;
  };

  const installProductReturn = () => {
    const point = currentPoint();
    if (!pointMatchesCurrentProduct(point)) return;

    // The duplicate same-URL entry makes the first native Safari Back
    // observable. The closure retains the point even if storage is cleared.
    if (!window.history.state?.[nativeBackKey]) {
      window.history.pushState({ ...(window.history.state || {}), [nativeBackKey]: true }, '', window.location.href);
    }
    window.addEventListener('popstate', () => {
      // Keep the point on the entry that native Back just selected. This
      // survives Safari BFCache restores even when sessionStorage was cleared.
      // The compact brp parameter is only present for this reload and is
      // removed immediately after the exact card is aligned.
      const returnUrl = new URL(point.returnUrl, window.location.origin);
      returnUrl.searchParams.set(nativeReturnParam, `${point.productId}~${point.offset}`);
      window.history.replaceState({ ...(window.history.state || {}), [stateKey]: point }, '', returnUrl);
      window.location.reload();
    }, { once: true });
  };

  const restoreCollectionPoint = () => {
    if (restoringCollectionPoint) return;
    const nativePoint = pointFromNativeUrl();
    const historyPoint = pointFromState();
    const point = nativePoint || historyPoint || safeRead();
    if (!point || window.location.pathname !== new URL(point.returnUrl, window.location.origin).pathname) return;
    const referrerPath = document.referrer && new URL(document.referrer).pathname;
    // Never restore an old fallback point after a customer intentionally opens
    // the collection again. A return is valid only from its history entry or
    // directly from the product that created it.
    if (!nativePoint && !historyPoint && referrerPath !== point.productPath) return;
    if (pageFromUrl() !== point.page) {
      window.location.replace(point.returnUrl);
      return;
    }

    restoringCollectionPoint = true;

    let cancelled = false;
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, () => { cancelled = true; }, { once: true, passive: eventName !== 'keydown' });
    });
    const align = () => {
      if (cancelled) return false;
      const product = document.querySelector(`${productSelector}[data-product-id="${point.productId}"]`);
      if (!product) return false;
      window.scrollTo(0, Math.max(0, window.scrollY + product.getBoundingClientRect().top - point.offset));
      return true;
    };
    window.history.scrollRestoration = 'manual';
    let restored = false;
    [0, 180, 500, 900].forEach((delay) => {
      window.setTimeout(() => {
        if (restored || !align()) return;
        restored = true;
        safeRemove();
        const state = { ...(window.history.state || {}) };
        delete state[stateKey];
        window.history.replaceState(state, '', point.returnUrl);
      }, delay);
    });
    // If the grid has not mounted yet, allow the products:update/pageshow
    // handlers to try again instead of permanently locking restoration.
    window.setTimeout(() => {
      if (!restored) restoringCollectionPoint = false;
    }, 1200);
  };

  document.addEventListener('pointerdown', prepareWithoutNavigation, true);
  document.addEventListener('touchstart', prepareWithoutNavigation, { capture: true, passive: true });
  document.addEventListener('click', openPreparedProduct, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const returnButton = event.target.closest('[data-product-return-to-collection], [data-cart-return-to-collection]');
    if (!returnButton || !returnToCollection(currentPoint())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  });
  window.addEventListener('scroll', scheduleVisiblePageSync, { passive: true });
  document.addEventListener('products:update', (event) => {
    const page = collectionProducts().map(pageFromMarker).filter(Boolean).pop() || pageFromUrl();
    markProducts(page);
    disableInstantProductLinks(event.target instanceof Element ? event.target : document);
  });
  // Safari can restore the original collection document from BFCache when the
  // visitor uses its native Back gesture. DOMContentLoaded does not run again
  // in that case, so restore the point from the collection history entry here.
  window.addEventListener('pageshow', () => {
    if (document.querySelector(collectionSelector)) restoreCollectionPoint();
  });

  const initialise = () => {
    if (document.querySelector(collectionSelector)) {
      markProducts(pageFromUrl(), false);
      disableInstantProductLinks();
      restoreCollectionPoint();
    }
    installProductReturn();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
